import { addMessages } from '@hana/i18n';

// Khoá chuỗi của thẻ khách Công nợ (ArCards.tsx). Dữ liệu mẫu (tên khách, cờ) không dịch.
addMessages('vi', {
  'ac.all': 'Tất cả', 'ac.over': 'Quá hạn', 'ac.hold': 'Bị giữ', 'ac.mine': 'Khách tôi', 'ac.obh': 'Chỉ chi hộ',
  'ac.sale': 'Sale {n}', 'ac.obhTip': 'Chi hộ treo · tách khỏi công nợ dịch vụ', 'ac.obhN': 'Chi hộ {n}', 'ac.inTerm': 'trong hạn',
});
addMessages('en', {
  'ac.all': 'All', 'ac.over': 'Overdue', 'ac.hold': 'On hold', 'ac.mine': 'My customers', 'ac.obh': 'Disbursements only',
  'ac.sale': 'Sale {n}', 'ac.obhTip': 'Open disbursements · kept apart from service receivables', 'ac.obhN': 'Disbursements {n}', 'ac.inTerm': 'not overdue',
});
